import React from 'react';
import { useOfferCountdown } from '../hooks/useOfferCountdown';
import { price } from '../data/salesPage';
export function OfferBar() {
  const {
    hours,
    minutes,
    seconds
  } = useOfferCountdown();
  return <a href="#comprar" className="sticky top-0 z-50 block bg-alert text-white transition-colors duration-150 ease-out hover:bg-[#ff6b6b]" data-id="element-139" data-mp="p1u1nsvnot6o">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2.5 text-center text-sm font-semibold sm:text-base" data-id="element-140" data-mp="t4idm9fo2g7v">
        <span className="uppercase tracking-wide" data-id="element-141" data-mp="k2r8b5p1gbej">Oferta de lanzamiento</span>
        <span className="flex items-center gap-2" data-id="element-142" data-mp="5dut8ookdy4f">
          <span className="line-through decoration-2 opacity-80" data-id="element-143" data-mp="5b09z0haejcl">{price.reference}</span>
          <span className="font-display font-black" data-id="element-144" data-mp="acfsolvzsdrt">{price.current}</span>
        </span>
        <span className="flex items-center gap-2" data-id="element-145" data-mp="3siay1uqi3bou">
          <span className="hidden sm:inline" data-id="element-146" data-mp="1b84wxr3qvbz">Termina en</span>
          <span className="rounded-md bg-ink px-2.5 py-0.5 font-display font-black tabular-nums text-bone" role="timer" aria-label={`Termina en ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-147" data-mp="1dkm38p1d1nz">
            {hours}:{minutes}:{seconds}
          </span>
        </span>
      </div>
    </a>;
}